import { render, staticRenderFns } from "./OcorrenciasAdesao.vue?vue&type=template&id=01d2e16e&scoped=true"
import script from "./OcorrenciasAdesao.vue?vue&type=script&lang=js"
export * from "./OcorrenciasAdesao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d2e16e",
  null
  
)

export default component.exports